<template>
	<div class="DynamicColumn">
		<div v-if="Array.isArray(data)">
			<DynamicColumn
			v-for="(item, index) in data"
			:reference="reference"
			:data="item"
			:simple="true"
			:key="index"
			></DynamicColumn>
		</div>
		<div v-else>
			<div v-if="data.type == 'role' || data.type == 'channel'">
				{{ data.singular }}
			</div>
			<c-user
			 v-else-if="data.type == 'user' || data.type == 'presentation'"
        	:simple="simple"
			:data="data"
			:canedit="(data.urls && Object.keys(data.urls).length > 0)"
			></c-user>
			<div v-else-if="data.type == 'asset' || data.type == 'image'">
				<router-link
 				class="st-table__link"

				v-if="reference && reference.urls && reference.urls.edit"
				:to="{path: reference.urls.edit}">
					<img
						:class="{'user-image': reference.fancyname, 'image': !reference.fancyname}"
						v-if="data.ext == 'png' || data.ext == 'gif' || data.ext == 'jpg' || data.ext == 'jpeg'"
						:src="data.url"
						:alt="(reference.fancyname ? reference.fancyname : reference.title) + ' image'"
					/>
				</router-link>
				<img
					v-else-if="data.ext == 'png' || data.ext == 'gif' || data.ext == 'jpg' || data.ext == 'jpeg'"
					:class="{'user-image': reference.fancyname, 'image': !reference.fancyname}"
					:src="data.url"
					:alt="(reference.fancyname ? reference.fancyname : reference.title) + ' image'"
				/>
			</div>
			<div v-else>
				<router-link
				class="st-table__link"

				v-if="reference && reference.urls && reference.urls.edit"
				:to="{path: reference.urls.edit}">
					{{ data }}
				</router-link>
				<span v-else>
					{{ data }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import CUser from '@/components/c-user';

export default {
	name: 'DynamicColumn',
	components: {
		CUser
	},
	props: {
		row: {
			default(){
				return {};
			}
		},
		data: {
			default(){
				return {};
			}
		},
		reference: {
			default(){
				return {};
			}
		},
		simple: {
			default: true
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DynamicColumn.vue